import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RespuestaFichaAnalisisCHVdto } from 'src/app/modelos/fichasAnalisis/RespuestaFichaAnalisisCHVdto';
import { RespuestaFichaAnalisisFiviDto } from 'src/app/modelos/fichasAnalisis/RespuestaFichaAnalisisFiviDto';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { VistaAnalisisInfI } from 'src/app/modelos/VistaAnalisisInf';
import { ESTADOS_PARA_PERIODO_CHV, FICHA_ANALISIS_INDIVIDUAL_CHV, FICHA_ANALISIS_MENSUAL_GENERAL_FIVI, FICHA_ANALISIS_TRIMESTRAL_GENERAL_FIVI, FICHA_ANALISIS_TRIMESTRAL_INDIVIDUAL_FIVI, HOST, PERIODO_ACTIVO_FIVI, PERIODO_POR_ANIO_MES_FIVI } from '../../global';
import { ANIOS_CALENDARIO_CHV } from '../../global';
import { ANIOS_CALENDARIO_FIVI } from '../../global';
import { PERIODO_ACTIVO_CHV } from '../../global';
import { FICHA_ANALISIS_GENERAL_CHV } from '../../global';

@Injectable({
  providedIn: 'root'
})
export class AnalisisService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }
//Lista años desde Vigencias
getListaAniosVigenciaChv():Observable<any[]>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + ANIOS_CALENDARIO_CHV;
  return this.http.get<any[]>(direccion,{'headers': header});
}
//Lista años desde Vigencias
getListaAniosVigenciaFivi():Observable<any[]>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + ANIOS_CALENDARIO_FIVI;
  return this.http.get<any[]>(direccion,{'headers': header});
}
//Consulta periodo activo CHV
consultarPeriodoActivoCHV():Observable<PeriodoReporteI>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + PERIODO_ACTIVO_CHV;
  return this.http.get<PeriodoReporteI>(direccion, {'headers': header});
}
//Consulta periodo activo FIVI
consultarPeriodoActivoFIVI():Observable<PeriodoReporteFiviI>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + PERIODO_ACTIVO_FIVI;
  return this.http.get<PeriodoReporteFiviI>(direccion, {'headers': header});
}
//Listado estados por periodo chv
EstadosParaPeriodoChv(id):Observable<VistaAnalisisInfI[]>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + ESTADOS_PARA_PERIODO_CHV + id;
  return this.http.get<VistaAnalisisInfI[]>(direccion, {'headers': header});
}
//ficha de analisis general chv
fichaAnalisisGeneralCHV(trimestre, anio):Observable<RespuestaFichaAnalisisCHVdto>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url +FICHA_ANALISIS_GENERAL_CHV+trimestre+"/"+anio;
  return this.http.get<RespuestaFichaAnalisisCHVdto>(direccion, {'headers': header});
}
//ficha de analisis individual chv
fichaAnalisisIndividualCHV(trimestre, anio, idFuente):Observable<RespuestaFichaAnalisisCHVdto>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url +FICHA_ANALISIS_INDIVIDUAL_CHV+trimestre+"/"+anio+"/"+idFuente;
  return this.http.get<RespuestaFichaAnalisisCHVdto>(direccion, {'headers': header});
}
//periodo fivi por año y mes
periodoFiviPorAnioMes(anio,mes):Observable<PeriodoReporteFiviI>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + PERIODO_POR_ANIO_MES_FIVI + anio + "/" + mes;
  return this.http.get<PeriodoReporteFiviI>(direccion, {'headers': header});
}
//ficha de analisis general mensual fivi
fichaAnalisisMensualGeneralFivi(mes, anio):Observable<RespuestaFichaAnalisisFiviDto>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url +FICHA_ANALISIS_MENSUAL_GENERAL_FIVI+mes+"/"+anio;
  return this.http.get<RespuestaFichaAnalisisFiviDto>(direccion, {'headers': header});
}
//ficha de analisis individual mensual fivi
fichaAnalisisMensualIndividualFivi(mes, anio, idFuente):Observable<RespuestaFichaAnalisisFiviDto>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url +"fichaAnalisisMensualIndividualFivi/"+mes+"/"+anio+"/"+idFuente;
  return this.http.get<RespuestaFichaAnalisisFiviDto>(direccion, {'headers': header});
}
//ficha de analisis general trimestral fivi
fichaAnalisisTrimestralGeneralFivi(trimestre, anio):Observable<RespuestaFichaAnalisisFiviDto>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url +FICHA_ANALISIS_TRIMESTRAL_GENERAL_FIVI+trimestre+"/"+anio;
  return this.http.get<RespuestaFichaAnalisisFiviDto>(direccion, {'headers': header});
}
//ficha de analisis individual trimestral fivi
fichaAnalisisTrimestralIndividualFivi(periodo, anio, idFuente):Observable<RespuestaFichaAnalisisFiviDto>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url +FICHA_ANALISIS_TRIMESTRAL_INDIVIDUAL_FIVI+periodo+"/"+anio+"/"+idFuente;
  return this.http.get<RespuestaFichaAnalisisFiviDto>(direccion, {'headers': header});
}

}
